<div class="modal-content funding">
    <div class="modal-header border-0">
        <h3 class="modal-title" id="modulesModalLabel">Agregar evidencia</h3>
        <button type="button" class="btn-close" (click)="modal.dismissAll()"></button>
    </div>
    <div class="modal-body p-4">
        <div class="row">
            <div class="col-xl-12 box-col-12">
                <div class="row tread-cards">
                    <div class="col-xl-6 col-sm-6">
                        <div class="card widget-1">
                            <div class="card-body common-box">
                                <div class="widget-icon primary widget-round">
                                    <app-common-svg-icons icons="payment"></app-common-svg-icons>
                                </div>
                                <div>
                                    <h4 class="f-w-600">Por fondear</h4>
                                    <span class="f-w-500 f-light f-12">{{ '0' | currency}}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-6 col-sm-6">
                        <div class="card widget-1">
                            <div class="card-body common-box">
                                <div class="widget-icon success widget-round">
                                    <app-common-svg-icons icons="bill"></app-common-svg-icons>
                                </div>
                                <div>
                                    <h4 class="f-w-600">Fondeado</h4>
                                    <span class="f-w-500 f-light f-12">{{ '0' | currency}}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="card-body transaction-list recent-orders">

            <form [formGroup]="evidenceFrom" class="mt-4">
                <div class="row">
                    <div class="col-md-12 mb-3">
                        <div class="mb-3">
                            <label>Evidencias</label>
                            <form class="dropzone dropzone-light custom-scrollbar customize-dropzone">
                                <dropzone [config]="config" [message]="textDropzone" (error)="onUploadError($event)" (success)="onUploadSuccess($event)" (removedFile)="onRemoveSuccess($event)">
                                </dropzone>
                            </form>
                        </div>
                    </div>

                </div>
            </form>

        </div>


    </div>
    <div class="modal-footer">
        <!-- Botones form-->
        <div class="d-flex justify-content-end gap-2 mt-2">
            <button type="button" class="btn btn-secondary col-auto" (click)="cancelForm()">Cancelar</button>
            <button type="button" class="btn btn-primary col-auto" (click)="saveEvidence()">Agregar</button>
        </div>
    </div>
</div>
